var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 22,
    viewBox: "0 0 42 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Apple_Pay",
    "data-name": "Apple Pay",
    transform: "translate(-38 -437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apple",
    transform: "translate(14.669 440.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_229_",
    d: "M28.387,73.9c-1.026,1.781-.374,4.484.761,6.122.566.819,1.14,1.555,1.926,1.555h.045a2.378,2.378,0,0,0,.894-.238,2.447,2.447,0,0,1,1.059-.251,2.3,2.3,0,0,1,1.008.243,2.135,2.135,0,0,0,.965.231c.885-.016,1.428-.81,1.907-1.51a6.693,6.693,0,0,0,.836-1.712l0-.011a.1.1,0,0,0-.053-.122l-.007,0a2.536,2.536,0,0,1-1.537-2.323A2.611,2.611,0,0,1,37.427,73.7l.01-.006a.1.1,0,0,0,.028-.14,2.871,2.871,0,0,0-2.258-1.226c-.064-.006-.13-.01-.2-.01a3.937,3.937,0,0,0-1.417.354,2.278,2.278,0,0,1-.679.2,2.221,2.221,0,0,1-.7-.205,3.4,3.4,0,0,0-1.238-.314h-.031A3.035,3.035,0,0,0,28.387,73.9Z",
    transform: "translate(0 -69.441)",
    fill: "current",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_230_",
    d: "M151.713,0a2.772,2.772,0,0,0-1.83.939,2.6,2.6,0,0,0-.657,1.926.1.1,0,0,0,.091.086c.042,0,.086,0,.129.005a2.345,2.345,0,0,0,1.727-.886,2.738,2.738,0,0,0,.643-1.981A.1.1,0,0,0,151.713,0Z",
    transform: "translate(-116.506 0)",
    fill: "current",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_30613",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 30613",
    d: "M2.426-3.047V0H1.037V-8.4H3.586a3.376,3.376,0,0,1,2.244.674,2.35,2.35,0,0,1,.8,1.9,2.623,2.623,0,0,1-.832,2,3.159,3.159,0,0,1-2.25.779Zm0-4.207v3.07h.9A2,2,0,0,0,4.693-4.6a1.485,1.485,0,0,0,.469-1.172q0-1.482-1.723-1.482ZM12.158,0H10.84V-.937h-.023A1.985,1.985,0,0,1,8.994.141,1.92,1.92,0,0,1,7.608-.34a1.681,1.681,0,0,1-.5-1.271q0-1.7,1.957-1.98l1.781-.252q0-1.283-1.219-1.283a2.9,2.9,0,0,0-1.934.738V-5.578a4.217,4.217,0,0,1,2.191-.562A1.994,1.994,0,0,1,12.158-3.9ZM10.846-2.947l-1.26.176a2,2,0,0,0-.882.284.83.83,0,0,0-.3.729.8.8,0,0,0,.272.624,1.055,1.055,0,0,0,.729.243,1.346,1.346,0,0,0,1.028-.437,1.548,1.548,0,0,0,.407-1.1ZM19.014-6,16.307.961a2.623,2.623,0,0,1-2.367,1.863,2.838,2.838,0,0,1-.715-.076V1.617a1.9,1.9,0,0,0,.586.105,1.209,1.209,0,0,0,1.137-.75l.4-.984L12.967-6h1.506L15.9-1.641q.023.082.105.434h.029q.029-.135.105-.422L17.643-6Z",
    transform: "translate(57 452)",
    fill: "current",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_1208",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 1208",
    transform: "translate(38 437)",
    fill: "none",
    stroke: "current",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 22,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 21,
    rx: 4.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePay);
export default __webpack_public_path__ + "static/media/applePay.b742a6b89ff06b74afdbf752a5ff06f2.svg";
export { ForwardRef as ReactComponent };